import utils from '../../../../utils';
import fetch from '../../../fetch';


const DataGrid = {
    selections: [],
    selectData: [],
    refresh: function() {

    }
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelectData = (data) => {
    DataGrid.selectData = data;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids
}

const getSelection =() => {
    return DataGrid.selections;
}

const columns = utils.columns(
    [
        {   
            key: '$index', 
            label: '序号',
            width: 10
        },
        {
            key: 'orgName', 
            label: '部门',
            width: 150
        },
        {
            key: 'className',
            label: '班级名称'
        },
        {
            key: 'currentTimesSum', 
            label: '已评价数'
        },
        {
            key: 'unEvalTimesSum',
            label:  '未评价数'
        },
        {
            key: 'limitedTimesSum',
            label: '总评价数'
        },
        {
            key: 'evalPercent', 
            label: '评价率'
        }
    ]
)

const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let params = []
    if(keywords['sort'] != '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('surveystudentanalysis/class/evalpercent?' + params.join('&'), keywords)
    .then((response) => {
        if(response.code == 200) {
            return response.payload.data;
        }
    }).then(data => (
        Object.assign({
            result: data.dataList || [],
            selects: (data.dataList || []).map(d => ({
                value: d.orgName,
                checked: false,
            })),
            checked: false,
            total: data.total,
            pageIndex: data.pageNum,
            pageSize: data.pageSize,
            notify: (data || []).length ? '' : '暂无数据...'
        }))
    )
}

export default {
    columns,
    onSelect,
    onSelectData,
    setRefresh,
    getSelection,
    querySearch
}